import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const ProfileInfoFilled: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 16)} fill="none">
            <Path
                d="M4.2392 4.21144C4.2392 2.43781 5.72836 1 7.56533 1C9.4023 1 10.8915 2.43781 10.8915 4.21144C10.8915 5.98507 9.4023 7.42288 7.56533 7.42288C5.72836 7.42288 4.2392 5.98507 4.2392 4.21144Z"
                fill={props.color}
            />
            <Path
                d="M9.69956 7.84555C9.0698 8.19107 8.34143 8.38839 7.56533 8.38839C6.76256 8.38839 6.01085 8.17728 5.36653 7.80941C3.95748 8.5648 3 10.0451 3 11.7477C3 14.2175 5.01472 15 7.5 15C9.98528 15 12 14.2175 12 11.7477C12 10.0719 11.0724 8.61137 9.69956 7.84555Z"
                fill={props.color}
            />
        </Svg>
    );
};

export default React.memo(ProfileInfoFilled);
